export { MAP_LAYER, OutlineMode } from 'components/Map/constants';

export {
    GEOJSON_BOUNDARY_TYPE,
    GEOJSON_PROPERTY
} from 'components/Map/hooks/useFeatures/constants';

export const BUFFER_METERS = 20;
